import React from "react";
import { useTranslation } from "react-i18next";
import { formatTimestamp } from "../../../utils/utils";
import { formatMetric } from "../../../utils/road";
import styles from "../../network_map/network_map.module.css";

export default function RoadImpacts({ impacts, error, onGo }) {
  const { t } = useTranslation();
  if (error) return <div className={styles.empty}>{t("roadmap.impacts.loadError")}</div>;
  if (!impacts) return <div className={styles.empty}>…</div>;
  if (impacts.length === 0) return <div className={styles.empty}>{t("roadmap.impacts.empty")}</div>;
  return (
    <div className={styles.changeList}>
      {impacts.map((hit, i) => (
        <div key={`${hit.pdui_id}-${hit.created_at}-${i}`} className={styles.changeRow}>
          <div className={`${styles.delta} ${styles.deltaDown}`}>{formatMetric("peak_g", hit.peak_g)}</div>
          <div className={styles.changeMain}>
            <div className={styles.changeScores}>{hit.pdui_name} · {formatTimestamp(hit.created_at)}</div>
            <div className={styles.changeMeta}>
              {t("roadmap.impacts.line", { n: hit.impacts, speed: formatMetric("speed_kmh", hit.speed_kmh), rms: formatMetric("rms_v", hit.rms_v) })}
            </div>
          </div>
          {hit.lat !== null && hit.lat !== undefined && (
            <button type="button" className={styles.smallButton} onClick={() => onGo({ lat: hit.lat, lon: hit.lon })}>{t("roadmap.changes.go")}</button>
          )}
        </div>
      ))}
    </div>
  );
}
